import React from 'react';
import ReactSpinnersBeatLoader from 'react-spinners/BeatLoader';
import ReactSpinnersClipLoader from 'react-spinners/ClipLoader';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import { Box, Typography } from '@material-ui/core';
import config from 'config/config';

const color = config.domainName === 'TMX' ? '#1D3140' : '#5383ff';

const BeatLoader = ({ loading = true, size = 10 }) => {
  return <ReactSpinnersBeatLoader color={color} loading={loading} size={size} />;
};

const ClipLoader = ({ loading = true, size = 25 }) => {
  return <ReactSpinnersClipLoader color={color} loading={loading} size={size} />;
};

const ClimbingLoader = () => {
  return (
    <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" height="100vh">
      <ClimbingBoxLoader color={color} loading={true} />
      <Typography style={{ paddingTop: 3, fontSize: '22.8px', color: '#d1d2db' }}>Loading...</Typography>
    </Box>
  );
};

export { BeatLoader, ClimbingLoader, ClipLoader };
